import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { fetchLauchMailresponse, updateCurrentStatus } from "../Redux/Approver";
import ApprovalContentTabs from "./ApprovalContentTabs";
import ApproverMailGeneration from "./ApproverMailGeneration";
import "./ApproverPage.css";
// import DataTable from "./NewTable";

const ApproverPage = () => {
  const [age, setAge] = useState(0);
  const [selectedMail, setSelectedMail] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const [activeScreen, setActiveScreen] = useState("default");
  const [openModal, setOpenModal] = useState(false);
  const [modalRecord, setModalRecord] = useState();
  const [status, setStatus] = useState();
  const [userQuery, setUserQuery] = useState("");
  const [clearEntire, setClearEntire] = useState(false);
  const [program, setProgram] = useState("");
  const [type, setType] = useState("");
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const launchMails = useSelector(state => state.approver.launchMails);
  const handleOpen = record => {
    setOpenModal(true);
    setModalRecord(record);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const columns = [{
    title: "SI#",
    dataIndex: "s.no",
    key: "s.no",
    render: (value, record) => record.sno
  }, {
    title: "Content Type",
    dataIndex: "subcategory",
    key: "subcategory",
    filters: formFilters("subcategory"),
    filteredValue: filteredInfo.subcategory || null,
    onFilter: (value, record) => record.subcategory == value,
    ellipsis: true
  }, {
    title: "Sub-Type",
    dataIndex: "mailtype",
    key: "mailtype",
    filters: formFilters("mailtype"),
    filteredValue: filteredInfo.mailtype || null,
    onFilter: (value, record) => record.mailtype == value,
    ellipsis: true
  }, {
    title: "Program Name",
    dataIndex: "programname",
    key: "programname",
    filters: formFilters("programname"),
    filteredValue: filteredInfo.programname || null,
    onFilter: (value, record) => record.programname == value
  }, {
    title: "Review Content",
    dataIndex: "contentlink",
    render: (_, record) => <p onClick={() => handleDispalyContent(record.template, record.uniqueID, record.isApproved, record.userQuery, record.programname, record.mailtype)} className="migrated-style-approverpage-def5a0-1">
     Review Content
    </p>,
    key: "contentlink"
  }, {
    title: "Date Created",
    dataIndex: "sendDate",
    key: "sendDate",
    filters: formFilters("sendDate"),
    filteredValue: filteredInfo.sendDate || null,
    onFilter: (value, record) => record.sendDate == value,
    sorter: (a, b) => {
      var aa = a.sendDate?.split("/").reverse().join();
      var bb = b.sendDate?.split("/").reverse().join();
      return aa < bb ? -1 : aa > bb ? 1 : 0;
    },
    sortOrder: sortedInfo.columnKey === "sendDate" ? sortedInfo.order : "descend",
    ellipsis: true
  }, {
    title: "Requestor Id",
    dataIndex: "user",
    key: "user",
    filters: formFilters("user"),
    filteredValue: filteredInfo.user || null,
    onFilter: (value, record) => record.user == value
  }, {
    title: "Status",
    dataIndex: "isApproved",
    key: "isApproved",
    filters: [{
      text: "Approved",
      value: 1
    }, {
      text: "Waiting for Approval",
      value: -1
    }, {
      text: "On hold",
      value: 2
    }, {
      text: "Not Applicable",
      value: 0
    }],
    filteredValue: filteredInfo.isApproved || null,
    onFilter: (value, record) => record.isApproved == value,
    ellipsis: true,
    render: (_, record) => <p>
     {record.isApproved == 1 ? "Approved" : record.isApproved == 0 ? "Not Applicable" : record.isApproved == 2 ? "On hold" : "Waiting for Approval"}
    </p>
  }, {
    title: "Details",
    render: (_, record) => <img onClick={() => handleOpen(record)} src={process.env.PUBLIC_URL + "/Images/desc_icon.png"} className="migrated-style-approverpage-def5a0-2"></img>
  }];
  const dispatch = useDispatch();
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const clearFilters = () => {
    setFilteredInfo({});
    setClearEntire(true);
  };
  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };
  function formFilters(x) {
    return Array.from(new Set(launchMails?.map(element => element[x])))?.map(item => {
      return {
        text: item,
        value: item
      };
    });
  }
  const handleDispalyContent = (value, uniqueID, status, userQuery, program, type) => {
    setSelectedMail(value);
    setUniqueID(uniqueID);
    setStatus(status);
    dispatch(updateCurrentStatus(status));
    setUserQuery(userQuery);
    setActiveScreen("contentscreen");
    setProgram(program);
    setType(type);
  };
  useEffect(() => {
    dispatch(fetchLauchMailresponse());
  }, []);
  return <>
   {activeScreen == "default" && <Stack sx={{
      margin: "0px 0px 40px 0px"
    }}>
     <Stack>
      {/* Ant table */}

      <div className="ant-table-custom-container">
       {/* <DataTable clearEntire={clearEntire} setClearEntire={setClearEntire} /> */}
       <ApprovalContentTabs />
      </div>
      <Modal hideBackdrop open={openModal} onClose={handleClose} aria-labelledby="child-modal-title" closeAfterTransition aria-describedby="child-modal-description" className="modal-container">
       <Box className="model">
        <div className="model_heading">
         <h5 className="paramodel">Additional Details</h5>
         <span className="close_btn_model" onClick={handleClose} tabIndex={0}>
          Close
         </span>
        </div>
        <hr />
        <div className="program-modal-details">
         <div className="program-details-wrap">
          <p className="program-details-header">Category: </p>
          <p className="program-details-value">{modalRecord?.category}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Program Name: </p>
          <p className="program-details-value">{modalRecord?.programname}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Type: </p>
          <p className="program-details-value">{modalRecord?.subcategory}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Content Sub-Type: </p>
          <p className="program-details-value">{modalRecord?.mailtype}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date Created: </p>
          <p className="program-details-value">{modalRecord?.sendDate}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Status: </p>
          <p className="program-details-value">
           {modalRecord?.isApproved == 1 ? "Approved" : modalRecord?.isApproved == 0 ? "Not Applicable" : modalRecord?.isApproved == 2 ? "On Hold" : "Waiting for Approval"}
          </p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Date of Approval: </p>
          <p className="program-details-value">{modalRecord?.approvedDate}</p>
         </div>
         <div className="program-details-wrap">
          <p className="program-details-header">Approved By: </p>
          <p className="program-details-value">{modalRecord?.approvedby}</p>
         </div>
        </div>
       </Box>
      </Modal>
     </Stack>
    </Stack>}
   {activeScreen != "default" && <>
     <ApproverMailGeneration selectedMail={selectedMail} setSelectedMail={setSelectedMail} uniqueID={uniqueID} setActiveScreen={setActiveScreen} status={status} userData={userQuery} program={program} type={type} />
    </>}
  </>;
};
export default ApproverPage;
